import {
  LogRoot_getInstance3817ahbflvs01 as LogRoot_getInstance,
  gczvdtmgupztxq as gc,
  printStackTrace214c8iyv3cpiv5 as printStackTrace2,
} from './debugger.js.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { clockMillis2lf7cl1xsmoff as clockMillis } from './clockMillis.mjs';
import { eachCount1imd75z0wkpbt as eachCount } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/GroupingJs.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_debugMode() {
  _init_properties_debugger_kt__md2uzj();
  return debugMode;
}
var debugMode;
function get_leaks() {
  _init_properties_debugger_kt__md2uzj();
  return leaks;
}
var leaks;
function set_lastGc(_set____db54di) {
  _init_properties_debugger_kt__md2uzj();
  lastGc = _set____db54di;
}
function get_lastGc() {
  _init_properties_debugger_kt__md2uzj();
  return lastGc;
}
var lastGc;
function set_lastGcReport(_set____db54di) {
  _init_properties_debugger_kt__md2uzj();
  lastGcReport = _set____db54di;
}
function get_lastGcReport() {
  _init_properties_debugger_kt__md2uzj();
  return lastGcReport;
}
var lastGcReport;
function get_leakLog() {
  _init_properties_debugger_kt__md2uzj();
  return leakLog;
}
var leakLog;
function get_Throwable_report() {
  _init_properties_debugger_kt__md2uzj();
  return Throwable_report;
}
var Throwable_report;
function get_viewDebugTarget() {
  _init_properties_debugger_kt__md2uzj();
  return viewDebugTarget;
}
var viewDebugTarget;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.abn_1 = LogRoot_getInstance();
      }
      bbn(tag) {
        return this.abn_1.bbn(tag);
      }
      hcv(entries) {
        this.abn_1.hcv(entries);
      }
      cbn(entries) {
        this.abn_1.cbn(entries);
      }
      icv(entries) {
        this.abn_1.icv(entries);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function checkLeakAfterDelay(_this__u8e3s4, milliseconds) {
  _init_properties_debugger_kt__md2uzj();
  // Inline function 'com.lightningkite.kiteui.afterTimeout' call
  var tmp = window;
  var handle = tmp.setTimeout(() => {
    gcIfNotVeryRecent();
    if (_this__u8e3s4.ra9() == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      get_leaks().v(_this__u8e3s4);
      recheckLeakAfterDelay(_this__u8e3s4, milliseconds);
    }
    return Unit_instance;
  }, convertToInt(milliseconds));
}
function report(_this__u8e3s4, context) {
  context = context === VOID ? '' : context;
  _init_properties_debugger_kt__md2uzj();
  return get_Throwable_report()(_this__u8e3s4, context);
}
function gcIfNotVeryRecent() {
  _init_properties_debugger_kt__md2uzj();
  if (clockMillis() - get_lastGc() > 100.0) {
    gc();
    set_lastGc(clockMillis());
  }
  if (clockMillis() - get_lastGcReport() > 1000.0) {
    set_lastGcReport(clockMillis());
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!get_leaks().i1()) {
      get_leakLog().hcv(['WARNING: ' + get_leaks().p1() + ' leaks...']);
      // Inline function 'kotlin.collections.groupingBy' call
      var this_0 = get_leaks();
      var tmp$ret$1 = new (gcIfNotVeryRecent$$inlined$groupingBy$1())(this_0);
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = eachCount(tmp$ret$1).d2().m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        get_leakLog().hcv(['  Leaked ' + element.f2() + ' of ' + toString(element.e2())]);
      }
    }
  }
}
function recheckLeakAfterDelay(_this__u8e3s4, milliseconds) {
  _init_properties_debugger_kt__md2uzj();
  // Inline function 'com.lightningkite.kiteui.afterTimeout' call
  var tmp = window;
  var handle = tmp.setTimeout(() => {
    gcIfNotVeryRecent();
    if (_this__u8e3s4.ra9() == null) {
      get_leaks().w3(_this__u8e3s4);
    } else {
      recheckLeakAfterDelay(_this__u8e3s4, milliseconds);
    }
    return Unit_instance;
  }, convertToInt(milliseconds));
}
var GCInfoClass;
function GCInfo() {
  if (GCInfoClass === VOID) {
    class $ {
      constructor(usage) {
        this.kcv_1 = usage;
      }
      toString() {
        return 'GCInfo(usage=' + this.kcv_1.toString() + ')';
      }
      hashCode() {
        return getBigIntHashCode(this.kcv_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GCInfo()))
          return false;
        if (!(this.kcv_1 === other.kcv_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GCInfo');
    GCInfoClass = $;
  }
  return GCInfoClass;
}
function infoOrAbove(_this__u8e3s4) {
  _init_properties_debugger_kt__md2uzj();
  return new (infoOrAbove$1())(_this__u8e3s4);
}
function Throwable_report$lambda(e, _unused_var__etf5q3) {
  _init_properties_debugger_kt__md2uzj();
  printStackTrace2(e);
  return Unit_instance;
}
var gcIfNotVeryRecent$$inlined$groupingBy$1Class;
function gcIfNotVeryRecent$$inlined$groupingBy$1() {
  if (gcIfNotVeryRecent$$inlined$groupingBy$1Class === VOID) {
    class $ {
      constructor($this) {
        this.lcv_1 = $this;
      }
      g6() {
        return this.lcv_1.m1();
      }
      g10(element) {
        var tmp0_safe_receiver = element.ra9();
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = getKClassFromExpression(tmp0_safe_receiver);
        }
        return tmp;
      }
      h6(element) {
        return this.g10((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
    }
    initMetadataForClass($);
    gcIfNotVeryRecent$$inlined$groupingBy$1Class = $;
  }
  return gcIfNotVeryRecent$$inlined$groupingBy$1Class;
}
var infoOrAbove$1Class;
function infoOrAbove$1() {
  if (infoOrAbove$1Class === VOID) {
    class $ {
      constructor($this_infoOrAbove) {
        this.mcv_1 = $this_infoOrAbove;
      }
      hcv(entries) {
      }
      bbn(tag) {
        return this.mcv_1.bbn(tag);
      }
      cbn(entries) {
        this.mcv_1.cbn(entries);
      }
    }
    initMetadataForClass($);
    infoOrAbove$1Class = $;
  }
  return infoOrAbove$1Class;
}
var properties_initialized_debugger_kt_wmk7x9;
function _init_properties_debugger_kt__md2uzj() {
  if (!properties_initialized_debugger_kt_wmk7x9) {
    properties_initialized_debugger_kt_wmk7x9 = true;
    debugMode = false;
    leaks = ArrayList().w();
    lastGc = clockMillis();
    lastGcReport = clockMillis();
    leakLog = LogRoot_getInstance().bbn('RViewLeaks');
    Throwable_report = Throwable_report$lambda;
    viewDebugTarget = null;
  }
}
//region block: exports
export {
  GCInfo as GCInfoouume21kiwko,
  checkLeakAfterDelay as checkLeakAfterDelayr9e6vxihbhwn,
  get_debugMode as get_debugMode2ku08uo1anfv,
  infoOrAbove as infoOrAbove10o4ftgq7f7ui,
  report as report1vfr9zf0i9d9p,
  get_viewDebugTarget as get_viewDebugTarget2umd1p7wjmzxt,
  Companion_getInstance as Companion_getInstanceok5aued8gko9,
};
//endregion

//# sourceMappingURL=debugger.mjs.map
